import { sharedCalculatorNav, sharedCalculatorTranslations } from './calculatorShared';

export const ru = {
  // Purchased Cars (Win Cars) view tabs
  winCarsView: {
    ourDealers: 'Наши Дилеры',
    allAuctionWins: 'Все Аукционные Победы',
    ourDealersHint: 'Только автомобили, купленные или назначенные нашим зарегистрированным дилерам.',
    allAuctionWinsHint: 'Все автомобили из аукционного потока (справочные данные).',
  },

  // Navigation
  nav: {
    dashboard: 'Панель',
    branches: 'Филиалы',
    managers: 'Менеджеры',
    dealers: 'Дилеры',
    subdealers: 'Субдилеры',
    winCars: 'Купленные Авто',
    accounts: 'Аккаунты',
    auctionFees: 'Аукционные Сборы',
    deliveryCost: 'Стоимость Доставки',
    statistics: 'Ставки',
    watchlist: 'Список наблюдения',
    tools: 'Инструменты',
    settings: 'Настройки',
    ...sharedCalculatorNav,
  },

  // Common
  common: {
    add: 'Добавить',
    edit: 'Редактировать',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    create: 'Создать',
    update: 'Обновить',
    back: 'Назад',
    refresh: 'Обновить',
    search: 'Поиск',
    actions: 'Действия',
    status: 'Статус',
    contact: 'Контакт',
    email: 'Эл. почта',
    phone: 'Телефон',
    name: 'Имя',
    username: 'Логин',
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    loading: 'Загрузка...',
    noDataFound: 'Данные не найдены',
    total: 'Всего',
    active: 'Активный',
    inactive: 'Неактивный',
    all: 'Все',
    filters: 'Фильтры',
  },

  watchlist: { notFound: 'не найдено', remove: 'Удалить из списка' },

  // Branches
  branches: {
    title: 'Управление филиалами',
    addBranch: 'Добавить филиал',
    editBranch: 'Редактировать филиал',
    createBranch: 'Создать новый филиал',
    branchName: 'Название филиала',
    branchCode: 'Код филиала',
    location: 'Местоположение',
    country: 'Страна',
    city: 'Город',
    address: 'Адрес',
    totalBranches: 'Всего филиалов',
    activeBranches: 'Активные филиалы',
    totalManagers: 'Всего менеджеров',
    totalDealers: 'Всего дилеров',
    totalSubdealers: 'Всего субдилеров',
    created: 'Создан',
    backToBranches: 'Вернуться к филиалам',
    noBranchesFound: 'Филиалы не найдены',
    deleteBranchConfirm: 'Вы уверены, что хотите удалить филиал',
  },

  // Managers
  managers: {
    title: 'Управление менеджерами',
    addManager: 'Добавить менеджера',
    editManager: 'Редактировать менеджера',
    createManager: 'Создать нового менеджера',
    firstName: 'Имя',
    lastName: 'Фамилия',
    assignToBranch: 'Назначить филиалу',
    totalManagers: 'Всего менеджеров',
    georgiaManagers: 'Филиал Грузии',
    dubaiManagers: 'Филиал Дубая',
    armeniaManagers: 'Филиал Армении',
    activeBids: 'Активные ставки',
    monthlyRevenue: 'Месячный доход',
    wonAuctions: 'Выигранные аукционы',
    backToManagers: 'Вернуться к менеджерам',
    noManagersFound: 'Менеджеры не найдены',
    deleteManagerConfirm: 'Вы уверены, что хотите удалить менеджера',
  },

  // Dealers
  dealers: {
    title: 'Управление дилерами',
    addDealer: 'Добавить дилера',
    editDealer: 'Редактировать дилера',
    createDealer: 'Создать нового дилера',
    totalDealers: 'Всего дилеров',
    georgiaDealers: 'Дилеры Грузии',
    dubaiDealers: 'Дилеры Дубая',
    armeniaDealers: 'Дилеры Армении',
    assignToManager: 'Назначить менеджеру',
    totalSubdealers: 'Всего субдилеров',
    totalSpent: 'Всего потрачено',
    successRate: 'Процент успеха',
    myBids: 'Мои ставки и машины',
    subdealersBids: 'Ставки и машины субдилеров',
    allBids: 'Все ставки и машины',
    myActiveBids: 'Мои активные ставки',
    subdealersActiveBids: 'Активные ставки субдилеров',
    totalCarsWon: 'Всего выигранных машин',
    backToDealers: 'Вернуться к дилерам',
    noDealersFound: 'Дилеры не найдены',
    deleteDealerConfirm: 'Вы уверены, что хотите удалить дилера',
    deleteDealer: 'Delete Dealer',
    loadingList: 'Loading dealers...',
    filtersActiveSuffix: 'filter(s) active',
    quickSearchPlaceholder: 'Search by Name, Username, Email, or Phone...',
    ctrlFHint: 'Ctrl+F / ⌘F',
    advancedFilters: 'Advanced Filters',
    branchFilterPh: 'Branch',
    managerFilterPh: 'Manager',
    allBranches: 'All Branches',
    allManagers: 'All Managers',
    clearFilters: 'Clear Filters',
    pageTotalShowing: 'Showing',
    pageTotalOf: 'of',
    pageTotalLabel: 'total',
    auctionAccountsTitle: 'Auction Accounts',
    auctionAccountsRequired:
      'Please select at least one primary auction account (Copart, IAAI, Manheim, or ACV).',
    passwordLeaveBlank: 'Password (leave empty to keep current)',
    passwordLabel: 'Password',
    phoneLabel: 'Phone',
    selectBranch: 'Select branch',
    selectManager: 'Select manager',
    toggleOn: 'On',
    toggleOff: 'Off',
    phFirst: 'e.g., Nikoloz',
    phLast: 'e.g., Baratashvili',
    phUsername: 'e.g., dealer.ge1',
    phEmail: 'dealer@bidmanager.com',
    phPhone: '+995 555 777 777',
    accountAmPlaceholder: '🇬🇪 GE Аккаунт',
    accountUsOptional: '🇺🇸 US Account (Optional)',
    noneOption: 'None',
    unknownBranch: 'Unknown Branch',
    bidLimitLabel: 'Bid Limit',
    activeBidsAmountLabel: 'Active Bids Amount',
    activeBidsSumLimitLabel: 'Active Bids Sum Limit',
    purchasedCarsLimitLabel: 'Purchased Cars Limit',
    lotsEventSettingLabel: 'Lots Event Setting',
    purchasedLotsSettingLabel: 'Purchased Lots Setting',
    showCalculatorWidget: 'Show Calculator Widget',
    showHelperTool: 'Show Helper Tool',
    showDiscountRow: 'Show Discount Row',
    fixedDiscountAmount: 'Fixed Discount Amount ($)',
    fixedDiscountHelp: 'Fixed discount amount in USD',
    iaaiCanadaTitle: 'IAAI (Canada)',
    calculatorSettingsSection: 'Calculator Settings',
    auctionLimitsSection: 'Аукцион и лимиты',
    visibilityHide: 'Hide',
    visibilityShow: 'Show',
    visibilityPartlyShow: 'Partly Show',
    visibilityWinningLots: 'Winning Lots',
    colDealer: 'Dealer',
    colBranch: 'Branch',
    colManager: 'Manager',
    colContact: 'Contact',
    colSubdealers: 'Subdealers',
    colActiveBids: 'Active Bids',
    colTotalSpent: 'Total Spent',
    colCreatedBy: 'Created By',
    colActions: 'Actions',
    tooltips: {
      bidLimit: 'Максимальный лимит ставки на один лот',
      activeBidsLimit: 'Сколько ставок пользователь уже сделал. Для новых пользователей установите 0',
      activeBidsSumLimit: 'Максимальная общая сумма в USD, которую пользователь может поставить на все лоты',
      purchasedCarsLimit: 'Максимальное количество машин, которые пользователь может купить',
      packageSlug: 'Тип пакета пользователя',
      lotsEventSetting: 'Управляет доступом к страницам "Мои ставки" и "/dashboard"',
      purchasedLotsSetting: 'Управляет доступом к просмотру страниц задолженности по оплате и истории платежей',
    },
  },

  // Subdealers
  subdealers: {
    title: 'Управление субдилерами',
    addSubdealer: 'Добавить субдилера',
    editSubdealer: 'Редактировать субдилера',
    createSubdealer: 'Создать нового субдилера',
    assignToDealer: 'Назначить дилеру',
    dealer: 'Дилер',
    branch: 'Филиал',
    manager: 'Менеджер',
    totalSpent: 'Всего потрачено',
    wonAuctions: 'Выигранные аукционы',
    activeBids: 'Активные ставки',
    backToSubdealers: 'Вернуться к субдилерам',
    noSubdealersFound: 'Субдилеры не найдены',
    deleteSubdealerConfirm: 'Вы уверены, что хотите удалить субдилера',
    tooltips: {
      bidLimit: 'Максимальный лимит ставки на один лот',
      activeBidsLimit: 'Сколько ставок пользователь уже сделал. Для новых пользователей установите 0',
      activeBidsSumLimit: 'Максимальная общая сумма в USD, которую пользователь может поставить на все лоты',
      purchasedCarsLimit: 'Максимальное количество машин, которые пользователь может купить',
      packageSlug: 'Тип пакета пользователя',
      lotsEventSetting: 'Управляет доступом к страницам "Мои ставки" и "/dashboard"',
      purchasedLotsSetting: 'Управляет доступом к просмотру страниц задолженности по оплате и истории платежей',
    },
  },

  // Bids & Cars
  bids: {
    lotNumber: 'Номер лота',
    vin: 'VIN',
    vehicle: 'Автомобиль',
    bidAmount: 'Сумма ставки',
    status: 'Статус',
    bidder: 'Ставка от',
    subdealer: 'Субдилер',
    won: 'ВЫИГРАНО',
    active: 'АКТИВНО',
    lost: 'ПРОИГРАНО',
    totalBids: 'Всего ставок',
    bidsAndCars: 'Ставки и машины',
    noBidsFound: 'Ставки не найдены',
  },

  layout: {
    footerBrand: 'Система Bidmanager',
  },

  // Auth
  auth: {
    login: 'Вход',
    logout: 'Выход',
    welcomeBack: 'С возвращением',
    signIn: 'Войти',
    profile: 'Профиль',
    loginSubtitle: 'Система управления автомобильными аукционами',
    usernamePlaceholder: 'Логин',
    passwordPlaceholder: 'Пароль',
    signingIn: 'Вход...',
    loginFailed: 'Ошибка входа. Проверьте учётные данные.',
    connectionError: 'Ошибка соединения. Проверьте интернет и повторите попытку.',
    forgotPasswordQuestion: 'Забыли пароль?',
    forgotPasswordTitle: 'Восстановление пароля',
    forgotPasswordHint: 'Введите email или имя пользователя, чтобы получить письмо для сброса пароля.',
    resetByEmail: 'По email',
    resetByUsername: 'По логину',
    emailPlaceholder: 'Введите email',
    forgotUsernamePlaceholder: 'Введите имя пользователя',
    sending: 'Отправка...',
    sendResetEmail: 'Отправить письмо',
    checkEmailTitle: 'Проверьте почту',
    checkEmailBody:
      'Если учётная запись существует, письмо для сброса пароля отправлено. Проверьте почту.',
    backToLogin: 'Назад ко входу',
    provideEmailOrUsername: 'Укажите email или имя пользователя',
    enterEmailAddress: 'Введите адрес email',
    enterUsernameRequired: 'Введите имя пользователя',
    requestFailedLater: 'Не удалось обработать запрос. Попробуйте позже.',
  },

  // Stats
  stats: {
    statistics: 'Статистика',
    dashboard: 'Панель управления',
  },

  // Dashboard
  dashboard: {
    systemAdminDashboard: 'Панель системного администратора',
    branchManagerDashboard: 'Панель менеджера филиала',
    dealerDashboard: 'Панель дилера',
    yourAuctionDashboard: 'Ваша аукционная панель',
    welcomeToDashboard: 'Добро пожаловать в панель Bidmanager',
    welcomeBack: 'С возвращением',
    systemOverview: 'системы',
    branchOverview: 'филиала',
    activityOverview: 'активности',
    overview: 'обзор',
    hereIsYour: 'Вот ваш',
    downloadApp: 'Скачать приложение',
    downloadAppDesc: 'Получите наше мобильное приложение для управления аукционами',
    downloadNow: 'Скачать сейчас',
    yourManager: 'Ваш менеджер',
    yourManagerDesc: 'Свяжитесь с вашим менеджером для помощи',
    whatsapp: 'WhatsApp',
    viber: 'Viber',
    tarifPlan: 'Тарифный план',
    basic: 'Базовый',
    planLimits: '5 машин • $10,000 лимит',
    upgradePlan: 'Обновить план',
    quickOverview: 'Быстрый обзор',
    priceList: 'Прайс-лист',
    oneActive: '1 Активный',
    twoOnline: '2 Онлайн',
    twoActive: '2 Активных',
    name: 'Имя',
    user: 'Пользователь',
    account: 'Аккаунт',
    auction: 'Аукцион',
    activity: 'Активность',
    action: 'Действие',
    managePriceLists: 'Управление прайс-листами',
    manageSubdealers: 'Управление субдилерами',
    manageAccounts: 'Управление аккаунтами',
    online: 'Онлайн',
    systemMetrics: 'Метрики системы',
    branchPerformance: 'Показатели филиала',
    yourActivity: 'Ваша активность',
    totalBranches: 'Всего филиалов',
    activeBranchesWorldwide: 'Активные филиалы по всему миру',
    branchManagers: 'Менеджеры филиалов',
    acrossAllBranches: 'Во всех филиалах',
    totalRevenue: 'Общий доход',
    totalPlatformRevenue: 'Общий доход платформы',
    mySubdealers: 'Мои субдилеры',
    activeInYourBranch: 'Активны в вашем филиале',
    currentlyInProgress: 'В процессе',
    byYourBranch: 'Вашим филиалом',
    currentlyBidding: 'Сейчас делает ставки',
    thisMonth: 'В этом месяце',
    totalBidsPlaced: 'Всего сделано ставок',
    totalWonAuctions: 'Всего выиграно аукционов',
  },

  // Form validation
  validation: {
    required: 'Это поле обязательно',
    invalidEmail: 'Неверный адрес электронной почты',
    passwordMismatch: 'Пароли не совпадают',
    minLength: 'Минимальная длина',
    maxLength: 'Максимальная длина',
  },

  // Notifications
  notifications: {
    createSuccess: 'Успешно создано',
    updateSuccess: 'Успешно обновлено',
    deleteSuccess: 'Успешно удалено',
    error: 'Произошла ошибка',
  },

  ...sharedCalculatorTranslations,

  // Delivery Cost
  deliveryCost: {
    title: 'Управление стоимостью доставки',
    addNew: 'Добавить новое местоположение',
    editLocation: 'Редактировать местоположение',
    location: 'Местоположение',
    fee: 'Стоимость',
    notes: 'Примечания',
    auction: 'Аукцион',
    country: 'Страна',
    armenia: 'Армения',
    georgia: 'Грузия',
    auctionCopart: 'Copart',
    auctionIaai: 'IAAI',
    auctionManheim: 'Manheim',
    statsCopart: 'Copart:',
    statsIaai: 'IAAI:',
    statsManheim: 'Manheim:',
    totalLocations: 'Всего местоположений',
    searchLocation: 'Поиск местоположения',
    searchPlaceholder: 'например, Атланта, Хьюстон...',
    addNotes: 'Добавить примечания...',
    notesPlaceholder: 'Необязательные примечания об этом местоположении...',
    confirmDelete: 'Подтвердить удаление',
    confirmDeleteMessage: 'Вы уверены, что хотите удалить эту стоимость доставки? Это действие нельзя отменить.',
    createSuccess: 'Стоимость доставки успешно создана',
    updateSuccess: 'Стоимость доставки успешно обновлена',
    deleteSuccess: 'Стоимость доставки успешно удалена',
    loadError: 'Не удалось загрузить стоимости доставки',
    saveError: 'Не удалось сохранить стоимость доставки',
    deleteError: 'Не удалось удалить стоимость доставки',
    validationError: 'Местоположение и стоимость обязательны',
  },
};

